import { mount } from 'svelte';
import App from './App.svelte';
import { initPwa, resumePathOnLaunch } from './lib/pwa';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import './app.css';

// Capture beforeinstallprompt synchronously — the event fires once per
// page load and may arrive before mount completes. Only Chromium-class
// browsers fire it; the InstallModal falls back to platform-specific
// instructions on Safari / Firefox.
initPwa();

const target = document.getElementById('app');
if (!target) throw new Error('No #app target in DOM');

// PWA service worker — production only so dev iteration isn't shadowed
// by a cached bundle.
if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.warn('Service worker registration failed:', err);
    });
  });
}

// Standalone cold launch: resume the trip the user was last on rather
// than the start_url's dashboard. Skip mounting so the dashboard
// doesn't flash before the replace lands.
const resumePath = resumePathOnLaunch();
if (resumePath !== null) {
  window.location.replace(resumePath);
} else {
  mount(App, { target });
}
